<template>
  <div class="">
    <card>
      <template v-slot:header>
        <h3>فیلتر پیامک ها</h3>
        <hr />
      </template>
      <template v-slot:content>
        <div class="container-fulid">
          <div class="row">
            <div class="col-md-4 col-12">
              <small>مشتری خود را انتخاب کنید</small>
              <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResulTblCostomer" :rownumintable="3" :defaultvalue="null" :action="'TblCrmCombo/GetCostomerProduct'" :method="'POST'" :idinput="'TblCostomer'" :keyItem="'TblCostomer'" :disabled="false" :ClassProps="'required'">
              </SearchableCombo>
            </div>
            <div class="col-md-3 col-12">
              <small>شماره موبایل مورد نظر خودرا انتخاب کنید </small>
              <input type="number" v-model="DataAxios.Mobile" class="form-control text-center" />
            </div>
            <div class="col-md-3 col-12">
              <small>تاریخ مورد نظر خودرا انتخاب کنید</small>
              <date-picker color="dimgray" v-model="DataAxios.Date" clearable :editable="true" placeholder="تا تاریخ "></date-picker>
            </div>
            <div class="col-md-2 col-12">
              <button class="btn btn-success mt-4 w-100" @click="FindSmsList"><i class="fad fa-search ml-2"></i>جستجو</button>
            </div>
          </div>
        </div>
      </template>
    </card>
    <card>
      <template v-slot:header>
        <h3>لیست پیامکـــ ـهای ارسالی</h3>
        <hr />
      </template>
      <template v-slot:content>
        <div class="container-fulid">
          <BnpGrid v-if="$store.state.renderComponentGrid" :hasRowNum="true" :propsColumn="Column" :propsRows="Rows">
            <!-- <template slot="Discount" slot-scope="props">
              <span>{{ $Comma3ragham(props.props.Discount) }}</span>
            </template> -->
          </BnpGrid>
        </div>
      </template>
    </card>
  </div>
</template>
<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import Card from '../../../components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'

export default {
  data() {
    return {
      DataAxios: { tblCustomerId: null, Mobile: '', Date: '' },
      Rows: [],
      Column: [
        { name: 'customerName', label: 'نام مشتری', visibility: true },
        { name: 'namFam', label: 'فرستنده', visibility: true },
        { name: 'fullName', label: 'گیرنده', visibility: true },
        { name: 'mobile', label: 'شماره موبایل', visibility: true },
        { name: 'msg', label: 'متن پیام', visibility: true },
        { name: 'tarix', label: 'تاریخ', visibility: true },
      ],
    }
  },
  components: { Card, SearchableCombo, datePicker: VuePersianDatetimePicker, BnpGrid },
  methods: {
    GetResulTblCostomer(val) {
      // console.log(val)
      this.DataAxios.tblCustomerId = val.id
    },
    FindSmsList() {
      console.log(this.DataAxios)
      let DataAxios_Data = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'Reports/SmsReport',
        Token: this.$session.get('Token'),
      }
      DataAxios_Data.ArryfildValue = this.DataAxios
      this.$PostData(DataAxios_Data).then((data) => {
        if (data.status == 'success') {
          if (data.data.length == 0) {
            this.$toasted.error('اطلاعاتی یافت نشد لطفا فیلتر خود را دقیق تر انتخاب کنید',{duration:1500})
            this.Rows=[]
          } else {
            this.Rows = data.data
          }
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        }
      })
    },
  },
}
</script>
<style scoped></style>
